import type { CartItem } from '../types';
import { isSupabaseConfigured, supabase } from './supabase';

export type CheckoutAddress = {
  cep: string;
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
};

type CheckoutResponse = {
  checkoutUrl?: string;
  orderId?: string;
  error?: string;
};

export async function createMercadoPagoCheckout(
  items: CartItem[],
  address: CheckoutAddress,
  paymentMethod: 'pix' | 'credit-card',
) {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error('O pagamento ainda não foi conectado ao servidor da loja.');
  }

  const { data: sessionData } = await supabase.auth.getSession();
  if (!sessionData.session) {
    throw new Error('Entre na sua conta antes de continuar para o pagamento.');
  }

  const response = await fetch(
    `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-mercado-pago-checkout`,
    {
      method: 'POST',
      headers: {
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        Authorization: `Bearer ${sessionData.session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: items.map(({ productId, color, size, quantity }) => ({
          productId,
          color,
          size,
          quantity,
        })),
        address,
        paymentMethod,
      }),
    },
  );
  const data = await response.json().catch(() => ({})) as CheckoutResponse;

  if (!response.ok) {
    throw new Error(data.error || 'Não foi possível iniciar o pagamento.');
  }

  if (!data.checkoutUrl) {
    throw new Error(data.error || 'O Mercado Pago não retornou o link de pagamento.');
  }

  return data;
}
